import React, { useState } from 'react';
import Breadcrumbs from 'src/components/shared/breadcrumbs/breadcrumbs';
import Box from '@amzn/meridian/box';
import Thumbnail from '@amzn/meridian/thumbnail';
import Text from '@amzn/meridian/text';
import './associateProfile.scss';
import { useParams } from 'react-router-dom';
import Row from '@amzn/meridian/row';
import { BADGE_PHOTO_THUMBNAIL_URL } from 'src/config/ExternalLinks';
import Link from '@amzn/meridian/link';
import Button from '@amzn/meridian/button';
import Tab, { TabGroup } from '@amzn/meridian/tab';

const AssociateProfile = () => {
  const { alias } = useParams();
  const [currentTab, setCurrentTab] = useState('tab-placements');

  const openNewJmrInNewTab = () => {
    window.open(`${window.location.origin}/newJmr/${alias}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="associate-profile">
      <Breadcrumbs
        breadcrumbList={[
          { url: '/placementsOverview', label: 'Placements Overview' },
          { url: `/associateProfile/${alias}`, label: `Associate (Ben Wilburn)` },
        ]}
      />
      <div className="associate-profile__header">
        <Row alignmentVertical="center">
          <Thumbnail source={BADGE_PHOTO_THUMBNAIL_URL + alias} />
          <Box>
            <Text type="h400">Ben Wilburn</Text>
            <Text type="b300">
              Software Engineer &bull; &nbsp;
              <Link
                type="secondary"
                href={`https://fclm-portal.amazon.com/search?term=${alias}`}
                target="_blank"
                rel="noopener noreferrer"
              >{`${alias}@`}</Link>
            </Text>
          </Box>
          <Button className="create-placement-button" onClick={openNewJmrInNewTab}>
            Create Placement
          </Button>
        </Row>
        <Row className="associate-profile__info" spacing="500">
          <AssociateProfileEmployeeInfo label="Employee ID" value="106161097" />
          <AssociateProfileEmployeeInfo
            label="Manager"
            value="Dhruv Prajay Prakash"
            url="https://phonetool.amazon.com/users/dhruvpj" // this will need to have a variable with the managers alias
          />
          <AssociateProfileEmployeeInfo label="Home Location" value="MDW7 | United States" />
          <AssociateProfileEmployeeInfo label="Shift" value="DCA-0730" />
          <AssociateProfileEmployeeInfo label="Modified Duty" value="68 of 180 days" />
        </Row>
      </div>
      <div className="associate-profile__content">
        <TabGroup value={currentTab} onChange={setCurrentTab}>
          <Tab value="tab-placements" aria-controls="tabpanel-placements" id="tab-placements">
            Placements
          </Tab>
          <Tab value="tab-restrictions" aria-controls="tabpanel-restrictions" id="tab-restrictions">
            Restrictions
          </Tab>
          <Tab value="tab-history" aria-controls="tabpanel-history" id="tab-history">
            History
          </Tab>
        </TabGroup>
        {currentTab === 'tab-placements' && (
          <div id="tabpanel-placements" aria-labelledby="tab-placements">
            <Text>Placements</Text>
          </div>
        )}
        {currentTab === 'tab-restrictions' && (
          <div id="tabpanel-restrictions" aria-labelledby="tab-restrictions">
            <Text>Restrictions</Text>
          </div>
        )}
        {currentTab === 'tab-history' && (
          <div id="tabpanel-history" aria-labelledby="tab-history">
            <Text>History</Text>
          </div>
        )}
      </div>
    </div>
  );
};

const AssociateProfileEmployeeInfo = ({ label, value, url }: { label: string; value: string; url?: string }) => {
  return (
    <Box>
      <Text color="secondary">{label}</Text>
      {url ? (
        <Link type="secondary" href={url} target="_blank" rel="noopener noreferrer">
          {value}
        </Link>
      ) : (
        <Text>{value}</Text>
      )}
    </Box>
  );
};

export default AssociateProfile;
